import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n          ", "\n          ", "\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { baseTextStyle } from './style/base';
import { baseTypographyMixin } from './mixins/base';
import { baseLinkStyle } from './style/link';
import { baseLinkMixin } from './mixins/link';
import { activePressedStyle } from '../tokens/pressed';
import { sizes } from './constants/sizes';
import { lineHeight } from '../style/line-height';
import { fontSize } from '../style/font-size';
var Link = styled.a.attrs(function (_ref) {
  var _ref$asSpan = _ref.asSpan,
      asSpan = _ref$asSpan === void 0 ? false : _ref$asSpan,
      _ref$asDiv = _ref.asDiv,
      asDiv = _ref$asDiv === void 0 ? false : _ref$asDiv,
      forwardedAs = _ref.forwardedAs;
  return _objectSpread(_objectSpread(_objectSpread({}, asSpan ? {
    as: 'span'
  } : {}), asDiv ? {
    as: 'div'
  } : {}), forwardedAs ? {
    as: forwardedAs
  } : {});
})(_templateObject(), baseTextStyle, baseLinkStyle, baseTypographyMixin, baseLinkMixin, activePressedStyle, function (_ref2) {
  var block = _ref2.block;
  return block ? "display: inline-block;" : '';
}, function (_ref3) {
  var flex = _ref3.flex;
  return flex ? "display: inline-flex;" : '';
}, function (_ref4) {
  var size = _ref4.size;
  return size ? css(_templateObject2(), fontSize((sizes[size] || sizes.default).fontSize), lineHeight((sizes[size] || sizes.default).lineHeight)) : '';
});
export default Link;